import axios from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || "http://localhost:4000",
  headers: { "Content-Type": "application/json" },
});

// Attach token automatically if present
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Same fix as apiClient.js — this is a SEPARATE axios instance (used by
// ExpenseForm.jsx, ReturnForm.jsx, etc.), so apiClient.js's interceptor
// never covered it. Any 401 here (expired/invalid token) should clear
// the stale session and send the person back to login, instead of
// surfacing a raw error with no explanation.
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      if (!window.location.pathname.startsWith("/login")) {
        window.location.href = "/login?reason=session_expired";
      }
    }
    return Promise.reject(error);
  }
);

export default api;
